import { mapAdminProduct, mapAdminProductListItem } from '@/entities/admin/model/mapAdminProduct'
import { mapNullableNonNegInt } from '@/shared/lib/mapApiScalars'

export function mapRestaurantProduct(raw) {
  if (!raw) {
    return null
  }

  return {
    ...mapAdminProduct(raw),
    stock: mapNullableNonNegInt(raw, 'stock'),
  }
}

export function mapRestaurantProductListItem(raw) {
  if (!raw) {
    return null
  }

  return {
    ...mapAdminProductListItem(raw),
    stock: mapNullableNonNegInt(raw, 'stock'),
  }
}

export function mapRestaurantProductList(dtos) {
  if (!Array.isArray(dtos)) {
    return []
  }
  return dtos.map(mapRestaurantProductListItem).filter((item) => item?.id)
}
